export interface FieldDraft {
  newValue?: unknown | null;
  notPossible?: boolean;
  comment?: string | null;
}

type DraftMap = Record<string, FieldDraft>;

function storageKey(dataRequestEntityId: string): string {
  return `data-request-draft:${dataRequestEntityId}`;
}

export function loadDraftMap(dataRequestEntityId: string): DraftMap {
  try {
    const raw = localStorage.getItem(storageKey(dataRequestEntityId));
    if (!raw) return {};
    return JSON.parse(raw) as DraftMap;
  } catch {
    return {};
  }
}

export function loadFieldDraft(dataRequestEntityId: string, fieldKey: string): FieldDraft | null {
  const map = loadDraftMap(dataRequestEntityId);
  return map[fieldKey] ?? null;
}

export function saveFieldDraft(
  dataRequestEntityId: string,
  fieldKey: string,
  draft: FieldDraft,
): void {
  const map = loadDraftMap(dataRequestEntityId);
  map[fieldKey] = draft;
  try {
    localStorage.setItem(storageKey(dataRequestEntityId), JSON.stringify(map));
  } catch {
    // Storage full or unavailable — silently ignore
  }
}

export function clearDraftMap(dataRequestEntityId: string): void {
  try {
    localStorage.removeItem(storageKey(dataRequestEntityId));
  } catch {
    // Silently ignore
  }
}
